import { clsx } from "clsx";
import { ReactNode } from "react";
import { twMerge } from "tailwind-merge";

import { BadgeTheme } from "@smart/bridge-types-basic";

import { badgeClassNames, badgeThemeClassNames } from "./class-names";
import { Icon, IconName } from "../icon";

export type BadgeProps = {
  label: string | ReactNode;
  theme?: BadgeTheme;
  isShade?: boolean;
  isRound?: boolean;
  iconLeft?: IconName;
  className?: string;
  dataTestId?: string;
  iconRight?: IconName;
};

export const Badge = ({
  label,
  theme = "neutral",
  isShade,
  isRound,
  iconLeft,
  iconRight,
  className,
  dataTestId,
}: BadgeProps) => (
  <div
    data-testid={dataTestId}
    className={twMerge(
      clsx(
        badgeClassNames({ isRound }),
        badgeThemeClassNames[theme][isShade ? "shade" : "tint"],
        className,
      ),
    )}
  >
    {iconLeft && <Icon className="h-4 w-4 py-[0.3rem]" name={iconLeft} />}
    {label && <span className="text-caption">{label}</span>}
    {iconRight && <Icon className="h-4 w-4 py-[0.3rem]" name={iconRight} />}
  </div>
);
